<div class="container-fluid">
    <div class="card-deck">
        <div class="card" *ngFor="[].constructor(3)">
            <img class="card-img-top" src="..." alt="Card image cap" loading="lazy">
            <div class="card-body">
                <h5 class="card-title">Card title</h5>
                <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional
                    content. This content is a little bit longer.</p>
                <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
            </div>
        </div>
    </div>
</div>